import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  CardText,
  CardFooter,
} from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';
import { Link } from 'react-router-dom';

const WaterReading = ({ reading, user, isManager }) => {
  const localDate = moment(reading.timestamp).format('llll');

  return (
    <Col md={4}>
      <Card className="mb-4">
        <CardHeader>{localDate}</CardHeader>
        <CardBody>
          {isManager && (
            <CardText>
              <Link to={`/water/${reading.id}`}>Reading ID: {reading.id}</Link>
            </CardText>
          )}
          {reading.masterReading && (
            <CardText>Master Reading: {reading.masterReading}</CardText>
          )}
          <CardText>
            Chl Free: {parseFloat(reading.freeChlorine).toFixed(2)} mg/l
          </CardText>
          {reading.totalChlorine && (
            <CardText>
              Chl Total: {parseFloat(reading.totalChlorine).toFixed(2)} mg/l
            </CardText>
          )}
          {reading.chemicalReading && (
            <CardText>
              Chem Reading: {parseFloat(reading.chemicalReading).toFixed(2)}
            </CardText>
          )}
          {reading.comments !== null && (
            <CardText>Comments: {reading.comments}</CardText>
          )}
        </CardBody>
        <CardFooter>{user.initials}</CardFooter>
      </Card>
    </Col>
  );
};

WaterReading.propTypes = {
  reading: PropTypes.object.isRequired,
};

export default WaterReading;



// WEBPACK FOOTER //
// ./src/components/reading/water/WaterReading.js